import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    expanded: { type: Boolean, default: false },
    expandText: { type: String, default: "See more" },
    collapseText: { type: String, default: "Show less" }
  }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.element.dataset.expanded = this.expandedValue
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = this.expandedValue
        ? this.collapseTextValue
        : this.expandTextValue
    }
  }
}
